// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon--1YZCe","InputGroup":"InputGroup--Irk_J","Select":"Select--V2kWQ"};